import { Button, Collapse, Flex, Grid, Paper, Select, TextInput } from "@mantine/core"
import { DatePickerInput } from "@mantine/dates"
import { BroomIcon, MagnifyingGlassIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next"
import { usePullSheetStatus } from "./pull-sheet-status"
import { ShippingFilters } from "./shipping-filters"

type Props = {
  opened: boolean
  filters: Omit<ShippingFilters, "searchQuery">
  setFilter: <K extends keyof ShippingFilters>(key: K, value: ShippingFilters[K]) => void
  clearFilters: () => void
  onSearch?: () => void
}

export function ShippingFilterPanel({ opened, filters, setFilter, clearFilters, onSearch }: Props) {
  const { t } = useTranslation(["delivery", "common"])
  const { options: statusOptions } = usePullSheetStatus()
  return (
    <Collapse expanded={opened}>
      <Paper p="md" mb="sm" withBorder radius="md">
        <Grid>
          <Grid.Col span={{ xs: 12, sm: 6, md: 4 }}>
            <TextInput label={t("delivery:pullSheet.refCode")} value={filters.refCode} onChange={(e) => setFilter("refCode", e.target.value)} placeholder={t("common:search.placeholder")} size="sm" />
          </Grid.Col>
          <Grid.Col span={{ xs: 12, sm: 6, md: 4 }}>
            <DatePickerInput label={t("delivery:pullSheet.loadingDate")} type="range" value={filters.loadingDate} onChange={(v) => setFilter("loadingDate", v)} placeholder={t("common:select", { ns: "common" })} valueFormat="YYYY-MM-DD" size="sm" clearable />
          </Grid.Col>
          <Grid.Col span={{ xs: 12, sm: 6, md: 4 }}>
            <Select label={t("delivery:pullSheet.loadingStatus")} value={filters.pullSheetStatus} onChange={(v) => setFilter("pullSheetStatus", v)} data={statusOptions} placeholder={t("common:select", { ns: "common" })} clearable size="sm" />
          </Grid.Col>
          <Grid.Col span={{ xs: 12, sm: 6, md: 4 }}>
            <DatePickerInput label={t("delivery:pullSheet.deliveryDate")} type="range" value={filters.deliveryDate} onChange={(v) => setFilter("deliveryDate", v)} placeholder={t("common:select", { ns: "common" })} valueFormat="YYYY-MM-DD" size="sm" clearable />
          </Grid.Col>
          <Grid.Col span={{ xs: 12, sm: 6, md: 4 }}>
            <TextInput label={t("delivery:pullSheet.deliveryStaff")} value={filters.staffFirstNameEmail} onChange={(e) => setFilter("staffFirstNameEmail", e.target.value)} placeholder={t("common:search.placeholder")} size="sm" />
          </Grid.Col>
          <Grid.Col span={{ xs: 12, sm: 6, md: 4 }}>
            <TextInput label={t("delivery:pullSheet.warehouseName")} value={filters.warehouseRefCodeName} onChange={(e) => setFilter("warehouseRefCodeName", e.target.value)} placeholder={t("common:search.placeholder")} size="sm" />
          </Grid.Col>
        </Grid>
        <Flex justify="flex-end" gap="sm" mt="md">
          <Button variant="default" size="sm" radius="md" leftSection={<BroomIcon size={16} />} onClick={clearFilters}>{t("common:actions.clear", { ns: "common" })}</Button>
          <Button variant="default" size="sm" radius="md" leftSection={<MagnifyingGlassIcon size={16} />} onClick={onSearch}>{t("common:actions.search", { ns: "common" })}</Button>
        </Flex>
      </Paper>
    </Collapse>
  )
}
